module.exports = __webpack_public_path__ + "static/media/12、安徽省滁州市餐厨垃圾处理PPP项目全过程咨询-min.943b2bd8.jpg";